/**
 * ./exercise6/Exercise6Workout.js
 *
 * This module runs **Exercise 6**, where users focus on a central circle until **the timer runs out**.
 * Background colors **switch every 5 seconds** to challenge **visual endurance and attention span**.
 * This Exercise is a short practice before doing Exercise 7.
 *
 */


import React, { useState, useEffect, useRef } from "react";
import "./Exercise6Workout.css"; // Importing the CSS file for styling
import { useNavigate, useLocation } from "react-router-dom";
import CloseIcon from "../components/icons/close.svg";
import BlueCircle from "./icons/BlueElipse.svg";
import YellowMask from "./icons/YellowMask.svg";
import ThreeGreenDots from "./icons/ThreeGreenDots.svg";
import InfoIcon from "../components/icons/InfoIcon.svg";
import RefreshButton from "../components/icons/RefreshButton.svg";
import { DEBUG_TIME } from "../config";

function Exercise6Workout() {
  const navigate = useNavigate();
  const location = useLocation();
  const isWarmup = location.state?.isWarmup;
  const exerciseNumber = location.state?.exerciseNumber;

  const handleClose = () => {
    navigate("/");
  };

  const [seconds, setSeconds] = useState(DEBUG_TIME ?? 90);
  const [isStarted, setIsStarted] = useState(false); // New state to manage delay
  const [backgroundColor, setBackgroundColor] = useState("green");
  const [nextBackgroundColor, setNextBackgroundColor] = useState("#D93AF2");

  useEffect(() => {
    console.log(exerciseNumber);  // Check that the exercise number is logged correctly

    const timeout = setTimeout(() => {
      setIsStarted(true); // Start the timer after the delay
    }, 2000); // 2-second delay

    return () => clearTimeout(timeout); // Cleanup timeout on unmount
  }, []);

  useEffect(() => {
    if (seconds % 5 == 0 && seconds !== 90) {
      let temp = backgroundColor;
      setBackgroundColor(nextBackgroundColor);
      setNextBackgroundColor(temp);
    }

    if (seconds <= 0) {
        const pause = setTimeout(() => {
            navigate("/Warmup3", {
               state: {
                 exerciseNumber: exerciseNumber,
                 isWarmup: true
               }
             });
          }, 2000); // 2-second delay
       

      // Navigate to the "OtherPage" when the timer hits 0
      return;
    }

    const interval = setInterval(() => {
      setSeconds((prevSeconds) => prevSeconds - 1);
    }, 2000);

    // Cleanup to clear interval on unmount
    return () => clearInterval(interval);
  }, [seconds]);

  const refreshPage = () => {
    window.location.reload();
  };

  return (
    <div className="exercise6-container">
      <div className="header-bar">
        <div className="close-icon-wrapper">
          <img
            src={CloseIcon}
            alt="close icon"
            className="close-icon"
            onClick={handleClose}
          />
        </div>
        <div className="close-icon-wrapper">
          <img
            src={RefreshButton}
            alt="refresh button"
            className="refresh-button"
            onClick={refreshPage}
          ></img>

          {/* NEXT STEP: import refresh button*/}
        </div>
      </div>
      <div className="spinning-circle">
        {/* <img src={BlueCircle} alt="blue elipse" className="blue-elipse" /> */}
        <img src={YellowMask} alt="yellow mask" className="yellow-mask" />
        {/* NEXT STEP: create elipse shaped three green dot svg for responsiveness ease*/}
        <img
          src={ThreeGreenDots}
          alt="three green dots"
          className="three-green-dots"
        />
        <div
          className="count-down"
          style={{ backgroundColor: backgroundColor }}
        >
          <b>{seconds}</b>
        </div>
      </div>
      <div className="instruction-box">
        <img src={InfoIcon} alt="info icon" className="instruction-icon" />
        Focus on the middle circle until the timer runs out. Maintain your focus
        to make the green circles disappear.
      </div>
    </div>
  );
}

export default Exercise6Workout;
